import { useCallback, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { objectToQuery, queryToObject } from 'common/helpers/filters.helper';

export function useQueryFilter<T extends Record<string, any>>(defaultFilter: T) {
  const history = useHistory();

  const [filter, setFilter] = useState<T>(() => {
    const query = queryToObject<T>(defaultFilter) as Partial<T>;

    return {
      ...defaultFilter,
      ...query,
    };
  });

  const updateFilter = useCallback((partial: Partial<T>, options?: { resetPage?: boolean; }) => {
    
    setFilter(prev => {
      const nextPageIndex =
      partial.pageIndex !== undefined
        ? partial.pageIndex
        : options?.resetPage === false
        ? prev.pageIndex
        : 1;

      return {
        ...prev,
        ...partial,
        pageIndex: nextPageIndex,
      };
    });
  }, []);

  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;

      return;
    }

    history.replace({
      search: objectToQuery(filter),
    });
  }, [filter, history]);

  return { filter, updateFilter, setFilter };
}
